let formatter: Intl.NumberFormat;
let shortFormatter: Intl.NumberFormat;

export const formatCurrency = (val: number | string, short = false): string => {
  if (!formatter) {
    formatter = new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 2,
    });
    shortFormatter = new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 0,
    });
  }
  if (val === undefined || val === null) return formatter.format(0);
  const number = parseFloat(val.toString());
  if (short && parseInt(val.toString()) === number) return shortFormatter.format(number);
  return formatter.format(number);
};
